import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-blue-600 text-white fixed w-full top-0 left-0 z-10 shadow-lg">
  <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
    <NavLink to="/" className="flex items-center">
    {/* <h1 className="heading-main">ZT();</h1> */}
    <img id='logo' src='/assets/ZT-logo.svg' alt='logo' className='h-16 w-auto'/>
    </NavLink>
    <nav className="space-x-6 items-center">
      <NavLink to="/" className="nav-link">
        Home
      </NavLink>
      <NavLink to="/about" className="nav-link">
       About
      </NavLink>
      <NavLink to="/projects" className="nav-link">
        Projects
      </NavLink>
      <NavLink to="/contact" className="nav-link">
        Contact
      </NavLink>
      {/* <NavLink to="/blog" className="nav-link">
        Blog
      </NavLink> */}
    </nav>
  </div>
</header>
  );
};

export default Header;
